import { render } from "./DriverReturnsReportPage.vue?vue&type=template&id=35eddfc0&ts=true"
import script from "./DriverReturnsReportPage.vue?vue&type=script&lang=ts"
export * from "./DriverReturnsReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__